import { AbstractControl, ValidationErrors } from '@angular/forms';
import { BaseValidationError } from '@shared/validators/validation-error/base-error';
import { BaseValidator } from '@shared/validators/base-validator';
import { TranslationService } from '@core/translation/translation.service';
import { Berth } from '@shared/models/berth';

export class BerthExistsValidator extends BaseValidator {

    public validationError: BaseValidationError;

    constructor(message?: string) {
        super();

        this.validationError = new BaseValidationError(
            'berthExists',
            message || TranslationService.translate('common.validation.pickBerthFromList')
        );
    }

    public validate({value}: AbstractControl): ValidationErrors {
        return !value || (value instanceof Berth && value.id != null) ?
            this.IS_VALID :
            this.IS_INVALID;
    }
}
